import { graphql } from '@apollo/client/react/hoc';
import { withRouter } from 'react-router-dom';
import categoriesQuery from './categoriesQuery.graphql';
import component from './component';

export default withRouter(graphql(categoriesQuery, {
  props: ({ data: { categories = [] } }) => ({ categories })
})(component));

